import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
  viewChild, AfterViewInit,
} from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { provideNgxMask } from 'ngx-mask'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { VehicleTypeService } from '../../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { ServiceTypeService } from '../../../../core/services/service/service-type/service-type.service'
import { ServiceSpecificationService } from '../../../../core/services/service/service-specification/service-specification.service'
import { LocationService } from '../../../../core/services/location/location/location.service'
import { TariffTypeService } from '../../../../core/services/tariff/tariff-type/tariff-type.service'
import { TariffService } from '../../../../core/services/tariff/tariff/tariff.service'
import { DriverTypeService } from '../../../../core/services/driver/driver-type/driver-type.service'
import { CurrencyInputDirective } from '../../../../shared/directives/currencyInput'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { convertCurrency } from '../../../../shared/utils/utils'
import { MatCheckbox } from '@angular/material/checkbox'
import { ItinerariesItemProposalCreateComponent } from '../../../itineraries/item-proposal/itineraries-item-proposal-create/itineraries-item-proposal-create.component'
import moment from 'moment/moment'
import { IntegerInputDirective } from '../../../../shared/directives/IntegerInput'
import { DecimalInputDirective } from '../../../../shared/directives/decimalInput'
import { CommissionDividerService } from '../../../../core/services/price-quote/commission-divider/commission-divider.service'
import { SearchTariffProposalComponent } from '../../../tariff/search-tariff-proposal/search-tariff-proposal.component'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { ProposalItemService } from '../../../../core/services/proposal/proposal-item/proposal-item.service'
import { PurchasesQuoteRequestItinerariesService } from '../../../../core/services/purchases/purchases-quote-request-itineraries/purchases-quote-request-itineraries.service'
import { MatSlideToggle } from '@angular/material/slide-toggle'

@Component({
  selector: 'item-proposal-include-form',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    CurrencyInputDirective,
    MatCheckbox,
    ItinerariesItemProposalCreateComponent,
    IntegerInputDirective,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    DecimalInputDirective,
    SearchTariffProposalComponent,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatAccordion,
    MatSlideToggle,
  ],
  templateUrl: './item-proposal-include-form.component.html',
  styleUrl: './item-proposal-include-form.component.scss',
  providers: [
    TariffService,
    TariffTypeService,
    DriverTypeService,
    LocationService,
    ServiceTypeService,
    ServiceSpecificationService,
    VehicleTypeService,
    ProposalItemService,
    provideNgxMask(),
  ],
  standalone: true,
})
export class ItemProposalIncludeFormComponent implements OnInit, AfterViewInit {
  constructor(
    private formBuilder: FormBuilder,
    private driverTypeService: DriverTypeService,
    private locationService: LocationService,
    private serviceTypeService: ServiceTypeService,
    private serviceSpecificationService: ServiceSpecificationService,
    private proposalItemService: ProposalItemService,
    private purchasesQuoteRequestItinerariesService: PurchasesQuoteRequestItinerariesService,
    private vehicleTypeService: VehicleTypeService,
    private commissionDividerService: CommissionDividerService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ItemProposalIncludeFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    this.item.data = data.item
    this.idClient = data.idClient
  }

  @Output() response = new EventEmitter()
  @ViewChild(SearchTariffProposalComponent)
  SearchTariffProposalComponent!: SearchTariffProposalComponent

  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')

  edit = false
  idClient = -1
  item: any = { user: false, data: [] }
  form: FormGroup = new FormGroup({})
  loading = false
  listLocation: any[] = []
  listTypeVehicle: any[] = []
  listTypeDriver: any[] = []
  listTypeService: any[] = []
  listItineraries: any[] = []
  listServiceSpecification: any[] = []
  listCommission: any[] = [
    { value: 'T', description: 'tg.mob', disabled: false },
    { value: 'C', description: 'Cliente', disabled: true },
    { value: 'P', description: 'Personalizado', disabled: false },
  ]

  commissionDividerClient: any = {
    taxa: 0,
    divisor: 0,
    comissao: 0,
  }

  commissionDividerTg: any = {
    taxa: 0,
    divisor: 0,
    comissao: 0,
  }

  tariffSelected: any = {}

  ngOnInit(): void {
    this.getLocation()
    this.getTypeService()
    this.getTypeVehicle()
    this.getTypeDriver()
    this.createForm()
    this.getCommissionDivider()
    this.getCommissionDivider(this.idClient)
    // if (this.edit) {
    //   this.fillForm(this.item)
    // }
  }

  ngAfterViewInit(): void {
    if (this.edit) {
      // if (this.item.tarifario.id == '' || !this.item.tarifario.id) {
      //   if (this.SearchTariffProposalComponent) {
      //     this.SearchTariffProposalComponent.fillPurchase()
      //   }
      // }
      this.fillForm(this.item)
    }
  }

  getCommissionDivider(id = -1) {
    if (id == -1) {
      this.commissionDividerService.getCommissionDividerDefault().subscribe({
        next: (response: ResponseRequestModel) => {
          // this.commissionDividerTg = {
          //   taxa: response.data.taxa,
          //   divisor: response.data.divisor,
          //   comissao: response.data.comissao,
          // }
          this.commissionDividerTg = {
            taxa:
              response && response.data && response.data.taxa
                ? response.data.taxa
                : 0,
            divisor:
              response && response.data && response.data.divisor
                ? response.data.divisor
                : 1,
            comissao:
              response && response.data && response.data.comissao
                ? response.data.comissao
                : 0,
          }
          if (!this.edit) {
            this.fillCommission(this.commissionDividerTg)
          }
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
    } else {
      this.commissionDividerService
        .getCommissionDividerbyClientId(id)
        .subscribe({
          next: (response: ResponseRequestModel) => {
            if (response.data) {
              this.commissionDividerClient = {
                taxa:
                  response && response.data && response.data.taxa
                    ? response.data.taxa
                    : 0,
                divisor:
                  response && response.data && response.data.divisor
                    ? response.data.divisor
                    : 1,
                comissao:
                  response && response.data && response.data.comissao
                    ? response.data.comissao
                    : 0,
              }
              this.listCommission[1].disabled = false
              if (!this.edit) {
                this.form.get('typeCommission')!.setValue('C')
                this.fillCommission(this.commissionDividerClient)
              }
            } else {
              this.commissionDividerClient = {
                taxa: 0,
                divisor: 1,
                comissao: 0,
              }
              this.listCommission[1].disabled = true
              if (!this.edit) {
                this.fillCommission(this.commissionDividerTg)
                this.form.get('typeCommission')!.setValue('T')
              }
            }
          },
          error: (err: ResponseRequestModel) => {
            console.error(err)
          },
          complete: () => {},
        })
    }
  }

  fillCommission(commission: any, clear = false) {
    if (clear == false) {
      this.form
        .get('commission')!
        .setValue(convertCurrency(commission.comissao))
      this.form.get('commission')!.disable()
      this.form.get('tax')!.setValue(convertCurrency(commission.taxa))
      this.form.get('tax')!.disable()
      this.form.get('divider')!.setValue(convertCurrency(commission.divisor))
      this.form.get('divider')!.disable()
    } else {
      this.form.get('commission')!.setValue(convertCurrency(1))
      this.form.get('commission')!.enable()
      this.form.get('tax')!.setValue(convertCurrency(1))
      this.form.get('tax')!.enable()
      this.form.get('divider')!.setValue(convertCurrency(1))
      this.form.get('divider')!.enable()
    }
  }

  onSelectionChangeType(event: MatSelectChange) {
    if (event.value == 'T') {
      this.fillCommission(this.commissionDividerTg)
    } else if (event.value == 'C') {
      this.fillCommission(this.commissionDividerClient)
    } else {
      this.fillCommission('', true)
    }
    this.calculateValues()
  }

  getLocation() {
    this.locationService.listLocation().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listLocation = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeService() {
    this.serviceTypeService.listServiceType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeService = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeVehicle() {
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeVehicle = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeDriver() {
    this.driverTypeService.listDriverType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeDriver = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  createItemProposal() {
    if (this.validItem()) {
      this.loading = true
      const model = this.createModel()
      this.proposalItemService
        .createProposalItemWithItineraries(model)
        .subscribe({
          next: (response: ResponseRequestModel) => {
            this.updateResquestPurchase(this.item.data.id)
            this.snackbar.success(response.message)
            this.response.emit(true)
            this.close()
          },
          error: (err: ErrorRequestModel) => {
            this.loading = false
            this.snackbar.errorRequest(err)
          },
          complete: () => {
            this.loading = false
            // this.form.reset()
          },
        })
    } else {
      this.snackbar.info(
        'Para compras/cotação, necessário tipo de serviço, serviço, endereço de Origem e Destino.',
      )
      this.loading = false
    }
  }

  updateResquestPurchase(id: any) {
    this.purchasesQuoteRequestItinerariesService
      .updateRequestPurchase(id)
      .subscribe({
        next: (response: ResponseRequestModel) => {},
        error: (err: ErrorRequestModel) => {
          this.snackbar.errorRequest(err)
        },
        complete: () => {},
      })
  }

  validItem() {
    if (this.tariffSelected.id) {
      return true
    } else {
      const element: any = this.SearchTariffProposalComponent.createPurchase()
      const destination: any = element.destination
      const origin: any = element.origin
      if (
        // destination.cep == '' ||
        // destination.logradouro == '' ||
        // destination.numero == '' ||
        // destination.bairro == '' ||
        destination.cidade == '' ||
        destination.estado == '' ||
        // origin.bairro == '' ||
        // origin.cep == '' ||
        // origin.logradouro == '' ||
        // origin.numero == '' ||
        origin.cidade == '' ||
        origin.estado == '' ||
        element.servicoId == 0 ||
        element.servicoId == '' ||
        element.tipoServicoId == 0 ||
        element.tipoServicoId == ''
      ) {
        return false
      } else {
        return true
      }
    }
  }

  checkForm() {
    if (this.form.valid) {
      return true
    } else {
      return false
    }
  }

  close() {
    this.dialogRef.close()
  }

  fillForm(item: any) {
    if (item) {
      this.tariffSelected = item.tarifario
      if (item.tarifario.id == '' || !item.tarifario.id) {
        if (this.SearchTariffProposalComponent) {
          this.SearchTariffProposalComponent.fillPurchase(item.tarifario)
        }
      }

      this.form.get('cost')!.setValue(item.custo)
      // this.form.get('costOvertime')!.setValue(item.custoHoraExtra)
      // this.form.get('costKmExtra')!.setValue(item.custoKmExtra)

      this.form.get('saleUnit')!.setValue(item.vendaUnitario)
      this.form.get('saleOvertime')!.setValue(item.saleHoraExtra)
      this.form.get('saleKmExtra')!.setValue(item.saleKmExtra)

      this.form.get('dateStart')!.setValue(item.dataInicio)
      this.form.get('timeStart')!.setValue(item.horaInicio)
      this.form.get('dateEnd')!.setValue(item.dataFinal)
      this.form.get('timeEnd')!.setValue(item.horaFinal)

      this.form.get('isCourtesy')!.setValue(item.isCortesia)
      this.form.get('isCommission')!.setValue(item.isComisionado)
      this.form.get('isExchange')!.setValue(item.isPermuta)

      this.form.get('numVehicle')!.setValue(item.numVeiculos)
      this.form.get('numPeople')!.setValue(item.numPessoas)

      this.form.get('saleTotal')!.setValue(item.vendaSemTaxa)
      this.form.get('taxValue')!.setValue(item.valorTaxa)
      this.form.get('saleTotalTax')!.setValue(item.venda)

      this.form.get('observation')!.setValue(item.observacao)
      this.form
        .get('mostrarObsPdf')!
        .setValue(item.mostrarObsPdf == 'S' ? true : false)

      this.listItineraries = item.intinerarios

      this.form.get('typeCommission')!.setValue(item.tipoComissao)
      this.fillCommission({
        taxa: item.taxa,
        divisor: item.divisor,
        comissao: item.comissao,
      })

      if (item.tipoComissao == 'P') {
        this.form.get('commission')!.enable()
        this.form.get('tax')!.enable()
        this.form.get('divider')!.enable()
      }

      this.blockField(true)
    }
  }

  createModel() {
    let model: any = {}
    let tariff: any = {}


    if (
      this.tariffSelected.id &&
      this.tariffSelected.id != '' &&
      this.tariffSelected.id != null &&
      this.tariffSelected.id != -1
    ) {
      tariff = {
        origem: this.tariffSelected.origem,
        destino: this.tariffSelected.destino,
        tipoServico: this.tariffSelected.tipoServico,
        servico: this.tariffSelected.servico,
        tipoVeiculo: this.tariffSelected.tipoVeiculo,
        tipoMotorista: this.tariffSelected.tipoMotorista,

        tarifario: this.tariffSelected,
        tarifarioId: this.tariffSelected.id,
        tipoTarifarioId: this.tariffSelected.tipoId,

        origemId: this.tariffSelected.origemId,
        destinoId: this.tariffSelected.destinoId,
        tipoServicoId: this.tariffSelected.tipoServicoId,
        servicoId: this.tariffSelected.servicoId,
        tipoVeiculoId: this.tariffSelected.tipoVeiculoId,
        tipoMotoristaId: this.tariffSelected.tipoMotoristaId,

        origin: this.tariffSelected.origin,
        destination: this.tariffSelected.destination,
        perimetroUrbano: this.tariffSelected.perimetroUrbano,
      }
    } else {
      const tarrifInfos = this.SearchTariffProposalComponent.createPurchase()

      tariff = {
        origem: tarrifInfos.origem,
        destino: tarrifInfos.destino,
        tipoServico: tarrifInfos.tipoServico,
        servico: tarrifInfos.servico,
        tipoVeiculo: tarrifInfos.tipoVeiculo,
        tipoMotorista: tarrifInfos.tipoMotorista,

        tarifario: tarrifInfos,

        tipoTarifarioId: tarrifInfos.tipoTarifarioId,

        origemId: tarrifInfos.origemId,
        destinoId: tarrifInfos.destinoId,
        tipoServicoId: tarrifInfos.tipoServicoId,
        servicoId: tarrifInfos.servicoId,
        tipoVeiculoId: tarrifInfos.tipoVeiculoId,
        tipoMotoristaId: tarrifInfos.tipoMotoristaId,

        origin: tarrifInfos.origin,
        destination: tarrifInfos.destination,
        perimetroUrbano: tarrifInfos.perimetroUrbano,
      }
    }
    model = {
      propostaId: this.item.data.id,
      tarifarioId:
        tariff.tarifarioId && tariff.tarifarioId != ''
          ? tariff.tarifarioId
          : null,
      tipoTarifarioId:
        tariff.tipoTarifarioId && tariff.tipoTarifarioId != ''
          ? tariff.tipoTarifarioId
          : null,
      origemId: tariff.origemId,
      destinoId: tariff.destinoId,
      tipoServicoId: tariff.tipoServicoId,
      servicoId: tariff.servicoId,
      tipoVeiculoId: tariff.tipoVeiculoId ?? 0,
      tipoMotoristaId: tariff.tipoMotoristaId ?? 0,
      numPessoas: parseInt(this.form.get('numPeople')?.value),
      numVeiculos: parseInt(this.form.get('numVehicle')?.value),
      valorUnitario: this.convertValueModel(this.form.get('saleUnit')?.value),
      valorVenda: this.convertValueModel(this.form.get('saleTotal')?.value),
      valorComTaxa: this.convertValueModel(
        this.form.get('saleTotalTax')?.value,
      ),
      valorTaxa: this.form.get('taxValue')?.value
        ? convertCurrency(this.form.get('taxValue')?.value)
        : 0,
      valorKmVenda: this.convertValueModel(this.form.get('saleKmExtra')?.value),
      valorHoraVenda: this.convertValueModel(
        this.form.get('saleOvertime')?.value,
      ),
      isPermuta: this.form.get('isExchange')?.value ? 'S' : 'N',
      isComissiona: this.form.get('isCourtesy')?.value ? 'S' : 'N',
      isCortesia: this.form.get('isCommission')?.value ? 'S' : 'N',
      dataInicio: moment(this.form.get('dateStart')!.value).format(
        'DD/MM/YYYY',
      ),
      horaInicio:
        this.form.get('timeStart')?.value == ''
          ? ''
          : this.form.get('timeStart')?.value + ':00',
      dataFinal: moment(this.form.get('dateEnd')!.value).format('DD/MM/YYYY'),
      horaFinal:
        this.form.get('timeStart')?.value == ''
          ? ''
          : this.form.get('timeStart')?.value + ':00',
      taxa: this.convertValueModel(this.form.get('tax')?.value),
      divisor: this.convertValueModel(this.form.get('divider')?.value),
      comissao: this.convertValueModel(this.form.get('commission')?.value),
      tipoDivisor: this.form.get('typeCommission')?.value,
      observacao: this.form.get('observation')?.value,
      mostrarObsPdf: this.form.get('mostrarObsPdf')?.value ? 'S' : 'N',
      itinerarios: this.getItineraries(tariff),
      perimetroUrbano: tariff.perimetroUrbano,
    }
    return model
  }

  convertValueModel(value: any) {
    if (value != '') {
      return typeof value != 'number' ? convertCurrency(value) : value
    } else {
      return 0
    }
  }

  getItineraries(tariff: any) {
    const model: any[] = []
    for (let index = 0; index < this.listItineraries.length; index++) {
      const element = this.listItineraries[index]
      model.push({
        localParada: element.descricao,
        cep: element.cep,
        logradouro: element.logradouro,
        numero: element.numero,
        bairro: element.bairro,
        complemento: element.complemento,
        cidade: element.cidade,
        estado: element.estado,
        latitude: element.latitude != '' ? element.latitude : null,
        longitude: element.longitude != '' ? element.longitude : null,
        horaParada: element.horaParada ?? null,
        tempoPermanencia: element.tempoPermanencia ?? null,
        atividades: element.atividades ?? null,
        trecho: element.trecho,
        areaTarifario:
          element.areaTarifario == 'S' || element.areaTarifario == 's'
            ? 'S'
            : 'N',
      })
    }

    if (
      // tariff.origin.cep != '' &&
      // tariff.origin.logradouro != '' &&
      // tariff.origin.numero != '' &&
      // tariff.origin.bairro != '' &&
      tariff.origin.cidade != '' &&
      tariff.origin.estado != ''
    ) {
      model.push({
        // localParada: 'Origem',
        localParada: tariff.origin.descricao,
        cep: tariff.origin.cep,
        logradouro: tariff.origin.logradouro,
        numero: tariff.origin.numero,
        bairro: tariff.origin.bairro,
        latitude: tariff.origin.latitude != '' ? tariff.origin.latitude : null,
        longitude:
          tariff.origin.longitude != '' ? tariff.origin.longitude : null,
        cidade: tariff.origin.cidade,
        estado: tariff.origin.estado,
        complemento: tariff.origin.complemento,
        trecho: 'O',
        areaTarifario: 'S',
        horaParada: tariff.origin.horaParada ?? null,
        tempoPermanencia: tariff.origin.tempoPermanencia ?? null,
        atividades: tariff.origin.atividades ?? null,
        // descricao: tariff.origin.descricao,
        descricao: tariff.origin.cidade,
      })
    }

    if (
      // tariff.destination.cep != '' &&
      // tariff.destination.logradouro != '' &&
      // tariff.destination.numero != '' &&
      // tariff.destination.bairro != '' &&
      tariff.destination.cidade != '' &&
      tariff.destination.estado != ''
    ) {
      model.push({
        localParada: tariff.destination.descricao,
        cep: tariff.destination.cep,
        logradouro: tariff.destination.logradouro,
        numero: tariff.destination.numero,
        bairro: tariff.destination.bairro,
        latitude:
          tariff.destination.latitude != ''
            ? tariff.destination.latitude
            : null,
        longitude:
          tariff.destination.longitude != ''
            ? tariff.destination.longitude
            : null,
        cidade: tariff.destination.cidade,
        estado: tariff.destination.estado,
        complemento: tariff.destination.complemento,
        trecho: 'D',
        areaTarifario: 'S',
        horaParada: tariff.destination.horaParada ?? null,
        tempoPermanencia: tariff.destination.tempoPermanencia ?? null,
        atividades: tariff.destination.atividades ?? null,
        // descricao: tariff.destination.descricao,
        descricao: tariff.destination.cidade,
      })
    }
    return model
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      tariff: [''],

      isCourtesy: [false],
      isCommission: [false],
      isExchange: [false],

      dateStart: ['', [Validators.required]],
      timeStart: [''],
      dateEnd: ['', [Validators.required]],
      timeEnd: [''],

      typeCommission: ['T'],
      commission: ['', [Validators.required]],
      divider: ['', [Validators.required]],
      tax: ['', [Validators.required]],

      numVehicle: [1, [Validators.min(1), Validators.required]],
      numPeople: [1, [Validators.min(1), Validators.required]],

      cost: ['', [Validators.required]],
      sale: [''],
      // costOvertime: ['', [Validators.required]],
      // costKmExtra: ['', [Validators.required]],

      saleUnit: ['', [Validators.required]],
      saleOvertime: ['', [Validators.required]],
      saleKmExtra: ['', [Validators.required]],

      saleTotal: ['', [Validators.required]],
      taxValue: ['', [Validators.required]],
      saleTotalTax: ['', [Validators.required]],
      observation: [''],
      mostrarObsPdf: [false],
    })
    this.blockField(true)
  }
  // getList(list: any[]): void {
  //   this.listItineraries = list
  // }

  getList(list: any[]): void {
    if (list.length > 0) {
      const listIti = []
      for (let i = 0; i < list.length; i++) {
        const element = list[i]
        listIti.push({
          ...element,
          areaTarifario:
            element.areaTarifario == 'S' || element.areaTarifario == 's'
              ? 'S'
              : 'N',
        })
      }
      this.listItineraries = list
    } else {
      this.listItineraries = []
    }
  }

  openDatepicker(type: 'dateStart' | 'dateEnd') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    }
  }

  treatmentType(typeId = 0) {
    if (typeId == 2) {
      this.form.get('typeCommission')?.setValue('P')
      // this.form.get('typeCommission')?.disable()
      this.form.get('commission')?.setValue(convertCurrency(0))
      this.form.get('commission')?.enable()
      this.form.get('divider')?.setValue(convertCurrency(1))
      this.form.get('divider')?.enable()
      this.form.get('tax')?.setValue(convertCurrency(5))
      this.form.get('tax')?.enable()
    } else {
      this.form.get('typeCommission')?.enable()
    }
  }

  selectTariff(element: any) {
    if (element.id != -1) {
      if (element.tipoTarifarioId == 2 || element.tipoId == 2) {
        this.treatmentType(2)
      }
      this.form.get('cost')?.setValue(convertCurrency(element.custo))
      // this.form
      //   .get('costOvertime')
      //   ?.setValue(convertCurrency(element.custoHoraExtra))
      // this.form
      //   .get('costKmExtra')
      //   ?.setValue(convertCurrency(element.custokmExtra))
      this.form
        .get('saleOvertime')
        ?.setValue(convertCurrency(element.custoHoraExtra))
      this.form
        .get('saleKmExtra')
        ?.setValue(convertCurrency(element.custokmExtra))
      //this.blockField(true)
      this.calculateValues()
    } else {
      this.treatmentType()
      this.form.get('cost')?.setValue(convertCurrency(element.custo))
      this.form.get('saleOvertime')?.setValue(convertCurrency(0))
      this.form.get('saleKmExtra')?.setValue(convertCurrency(0))
    }
    this.tariffSelected = element
    this.calculateValues()
  }

  locationTariff(element: any) {
    this.tariffSelected = { ...this.tariffSelected, ...element }
  }

  blockField(block = false) {
    if (block) {
      this.form.get('cost')?.disable()
      // this.form.get('costOvertime')?.disable()
      // this.form.get('costKmExtra')?.disable()

      this.form.get('sale')?.disable()
      this.form.get('saleOvertime')?.disable()
      this.form.get('saleKmExtra')?.disable()

      this.form.get('saleUnit')?.disable()
      this.form.get('saleTotal')?.disable()
      this.form.get('saleTotalTax')?.disable()
      this.form.get('taxValue')?.disable()
    } else {
      this.form.get('cost')?.enable()
      this.form.get('costOvertime')?.enable()
      this.form.get('costKmExtra')?.enable()
    }
  }

  getValueNumber(value: string | number) {
    if (typeof value == 'string') {
      return parseFloat(value.replaceAll('.', '').replaceAll(',', '.'))
    } else if (typeof value == 'number') {
      return value
    } else {
      return 0.0
    }
  }

  calculateValues() {
    let divider = this.getValueNumber(
      this.form.get('divider')?.value == '' ||
        this.form.get('divider')?.value == '0'
        ? 1
        : this.form.get('divider')?.value,
    )
    let tax = this.getValueNumber(this.form.get('tax')?.value)
    const commission = this.getValueNumber(this.form.get('commission')?.value)
    let cost = this.getValueNumber(this.form.get('cost')?.value)
    // let costKm = this.getValueNumber(this.form.get('costKmExtra')?.value)
    // let costTime = this.getValueNumber(this.form.get('costOvertime')?.value)
    const vehicles = parseInt(this.form.get('numVehicle')?.value)

    // let saleUnit = parseFloat((cost / divider).toFixed(2))
    // // let saleKm = parseFloat((costKm + costKm / divider).toFixed(2))
    // // let saleTime = parseFloat((costTime + costTime / divider).toFixed(2))
    // let sale = parseFloat((saleUnit * vehicles).toFixed(2))
    // let saleTax = parseFloat((sale + (sale * tax) / 100).toFixed(2))
    // let taxValue = parseFloat((saleTax - sale).toFixed(2))
    //
    // saleUnit = Math.ceil(!isFinite(saleUnit) ? 0 : (saleUnit ?? 0))
    // sale = Math.ceil(!isFinite(sale) ? 0 : (sale ?? 0))
    // saleTax = Math.ceil(!isFinite(saleTax) ? 0 : (saleTax ?? 0))
    // taxValue = Math.ceil(!isFinite(taxValue) ? 0 : (taxValue ?? 0))

    let saleUnit = 0
    if (typeof cost == 'string') {
      // @ts-ignore
      cost = parseFloat(cost)
    }
    if (typeof divider == 'string') {
      // @ts-ignore
      divider = parseFloat(divider)
    }
    saleUnit = cost / divider
    saleUnit = Math.ceil(!isFinite(saleUnit) ? 0 : (saleUnit ?? 0))

    let sale = 0
    sale = saleUnit * vehicles
    sale = Math.ceil(!isFinite(sale) ? 0 : (sale ?? 0))

    let taxValue = 0
    if (typeof tax == 'string') {
      // @ts-ignore
      tax = parseFloat(tax)
    }
    taxValue = (sale * tax) / 100
    taxValue = Math.ceil(!isFinite(taxValue) ? 0 : (taxValue ?? 0))

    let saleTax = sale + taxValue
    saleTax = Math.ceil(!isFinite(saleTax) ? 0 : (saleTax ?? 0))

    this.form
      .get('saleUnit')
      ?.setValue(
        isNaN(saleUnit) ? convertCurrency(0) : convertCurrency(saleUnit),
      )
    this.form
      .get('saleTotal')
      ?.setValue(isNaN(sale) ? convertCurrency(0) : convertCurrency(sale))
    this.form
      .get('taxValue')
      ?.setValue(
        isNaN(taxValue) ? convertCurrency(0) : convertCurrency(taxValue),
      )
    this.form
      .get('saleTotalTax')
      ?.setValue(isNaN(saleTax) ? convertCurrency(0) : convertCurrency(saleTax))

    // this.form.get('saleKmExtra')?.setValue(convertCurrency(saleKm))
    // this.form.get('saleOvertime')?.setValue(convertCurrency(saleTime))
    // this.form
    //   .get('saleUnit')
    //   ?.setValue(isNaN(saleUnit) ? '' : convertCurrency(saleUnit))
    //
    // this.form
    //   .get('saleTotal')
    //   ?.setValue(isNaN(sale) ? '' : convertCurrency(sale))
    // this.form
    //   .get('taxValue')
    //   ?.setValue(isNaN(taxValue) ? '' : convertCurrency(taxValue))
    // this.form
    //   .get('saleTotalTax')
    //   ?.setValue(isNaN(saleTax) ? '' : convertCurrency(saleTax))
  }
}
